import { Injectable, NgZone } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef } from '@angular/material/snack-bar';
import { UserNotificationComponent } from '@app/core/modules/user-notification/user-notification.component';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserNotification, NotificationCategory } from '@app/core/modules/user-notification/models/UserNotification';

export class UserNotificationRef {
  constructor(private ref: MatSnackBarRef<UserNotificationComponent>) {}
}

@Injectable()
export class UserNotificationService {
  private readonly durationInSeconds = 4;
  private readonly _notificationStorage$: BehaviorSubject<UserNotification[]>;

  public readonly userNotifications$: Observable<UserNotification[]>;

  constructor(private _snackBar: MatSnackBar, private _zone: NgZone) {
    this._notificationStorage$ = new BehaviorSubject<UserNotification[]>([]);
    this.userNotifications$ = this._notificationStorage$.asObservable();
  }

  public publishUserNotification(userNotification: UserNotification) {
    const snackBarConfig: MatSnackBarConfig<UserNotification> = {
      politeness: 'off',
      verticalPosition: 'bottom',
      horizontalPosition: 'center',
      duration: this.durationInSeconds * 1000,
      data: userNotification
    };
    this._zone.run(() => {
      this._snackBar.openFromComponent(UserNotificationComponent, snackBarConfig);
    });
  }

  public savedNotification() {
    const snackBarConfig: MatSnackBarConfig<UserNotification> = {
      politeness: 'off',
      verticalPosition: 'bottom',
      horizontalPosition: 'center',
      duration: this.durationInSeconds * 1000,
      data: {
        message: 'Die Speicherung war erfolgreich!',
        notificationCategory: NotificationCategory.Success
      }
    };
    this._zone.run(() => {
      this._snackBar.openFromComponent(UserNotificationComponent, snackBarConfig);
    });
  }

  public errorNotification() {
    const snackBarConfig: MatSnackBarConfig<UserNotification> = {
      politeness: 'off',
      verticalPosition: 'bottom',
      horizontalPosition: 'center',
      duration: this.durationInSeconds * 1000,
      data: {
        message: 'Beim Speichern ist ein Fehler aufgetreten',
        notificationCategory: NotificationCategory.Error
      }
    };
    this._zone.run(() => {
      this._snackBar.openFromComponent(UserNotificationComponent, snackBarConfig);
    });
  }
}
